
function every(array: any[]): boolean {
    return array.every((val) => !!val);
};
  
export default every;